import { gql } from '@apollo/client';

export const ARCHIVE_FUNDER = gql`
  mutation archiveFunder($id: ID!) {
    archiveFunder(id: $id) {
      id
    }
  }
`;
